export default __webpack_public_path__ + "static/media/logo-veep.51a87e6a.svg";